// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"About_aboutContainer__18zvk","pageContent":"About_pageContent__b0-Ug","titleContainer":"About_titleContainer__2OBGY","logoLink":"About_logoLink__13Ido"};